
import BaseExpansion from "@/components/base/BaseExpansion.vue";
import BaseRadio from "@/components/base/BaseRadio.vue";
import BaseSvg from "@/components/base/BaseSvg.vue";
import ConfirmField from "@/components/bookingflow/steps/checkout/insurance/InsuranceConfirmField.vue";
import useInsuranceEffect from "@/composables/useInsuranceEffect";
import { ExtraTypeEnum, InsuranceConfirmationEnum } from "@/models/enums";
import { Insurance } from "@/models/www/Insurance";
import { InsuranceConfirmationState } from "@/models/www/store/InsuranceState";
import { useInsuranceStore } from "@/store/insurance";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { computed, defineComponent, PropType, reactive, watch } from "vue";
import InsuranceOption from "./InsuranceOption.vue";

export default defineComponent({
	components: {
		BaseRadio,
		BaseSvg,
		BaseExpansion,
		InsuranceOption,
		ConfirmField
	},
	props: {
		insurances: {
			type: Array as PropType<Insurance[]>,
		},
	},
	setup() {
		const insuranceStore = useInsuranceStore();

		useInsuranceEffect();

		const confirmFields = [
			InsuranceConfirmationEnum.MainResidency,
			InsuranceConfirmationEnum.PolicyRequirement,
			InsuranceConfirmationEnum.DuplicateCover,
			InsuranceConfirmationEnum.MedicalCondition,
			InsuranceConfirmationEnum.ForbiddenActivity,
		];

		const getInsuranceConfirmationState = (type: InsuranceConfirmationEnum) => {
			return insuranceStore.getConfirmations.find((c) => c.type === type)
				?.value;
		};

		const extendInsurance = computed(() => insuranceStore.getExtendInsurance);

		const state = reactive({
			needInsurance: getInsuranceConfirmationState(
				InsuranceConfirmationEnum.NeedInsurance
			),
			confirmInsurance: getInsuranceConfirmationState(
				InsuranceConfirmationEnum.Confirm
			),
			extendInsurance: extendInsurance.value
		});

		const rules = {
			needInsurance: {
				v: helpers.withMessage(
					() => "Please select",
					(value: boolean) => typeof value !== "undefined"
				),
			},
			confirmInsurance: {}
		};

		const v$ = useVuelidate(rules, state);

		watch(state, (current) => {
			if (
				current.needInsurance === false ||
				current.confirmInsurance === false
			) {
				insuranceStore.setPassengers([]);
				insuranceStore.setConfirmations([]);
				if (current.needInsurance === false) {
					state.confirmInsurance = undefined;
				}
			}
			insuranceStore.setConfirmation({
				type: InsuranceConfirmationEnum.Confirm,
				value: current.confirmInsurance,
			} as InsuranceConfirmationState);

			insuranceStore.setConfirmation({
				type: InsuranceConfirmationEnum.NeedInsurance,
				value: current.needInsurance,
			} as InsuranceConfirmationState);
		});

		return {
			confirmFields,
			ExtraTypeEnum,
			v$,
			InsuranceConfirmationEnum,
		};
	},
});
